var DAYS_NAMES = ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'];
var DAYS_VALUES = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];
(function () {
    'use strict';

    function WeeklyWorkDaysController($scope, $state, translate, translatePartialLoader, DialogService) {
        var $ctrl = this;

        $ctrl.checkedDays = checkAllAsDefault();
        $ctrl.checkedDays = getCheckedDays();
        $ctrl.checkChanged = onCheckChanged;
        $ctrl.allWeekDays = getAllWeekDays();

        //
        $scope.$watch('$ctrl.selectedWeeklyScheduleInfo', function () {
            //       if($ctrl.selectedWeeklyScheduleInfo.weekdays!=undefined) {
            $scope.$watch('$ctrl.selectedWeeklyScheduleInfo.weekdays', function () {

                $ctrl.checkedDays = getCheckedDays();
                $ctrl.allWeekDays = getAllWeekDays();

            }, true);


            //     }


        }, true);

        function onCheckChanged() {


            setCheckedDays();
        }

        function checkAllAsDefault() {
            var retChekDays = [];
            //angular.forEach(DAYS_VALUES, function (val) {
            //    retChekDays.push(val);
            //});
            return retChekDays;
        }

        function getCheckedDays() {


            if ($ctrl.selectedWeeklyScheduleInfo != undefined && $ctrl.selectedWeeklyScheduleInfo.weekdays != undefined) {
                var weekDays = $ctrl.selectedWeeklyScheduleInfo.weekdays;
                if (weekDays.length > 0) {
                    var retChekDays = [];
                    angular.forEach(weekDays, function (val) {
                        retChekDays.push(val.weekday);
                    });
                    return retChekDays;

                }
            }
            return $ctrl.checkedDays;
        }

        function setCheckedDays() {

            $ctrl.selectedWeeklyScheduleInfo.weekdays = [];
            angular.forEach($ctrl.allWeekDays, function (val) {
                if (val.checked) {

                    $ctrl.selectedWeeklyScheduleInfo.weekdays.push({weekday: val.value, timePeriod: val.timePeriod});
                }
            });


        }

        function getAllWeekDays() {
            var retList = [];

            for (var i = 0; i < 7; i++) {
                var timePeriod;
                var hasChecked = $ctrl.checkedDays.indexOf(DAYS_VALUES[i]) > -1;
                if (hasChecked) {
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == DAYS_VALUES[i]) {

                            timePeriod = val.timePeriod;

                        }
                    });

                    // timePeriod = $ctrl.checkedDays[$ctrl.checkedDays.indexOf(DAYS_VALUES[i])].timePeriod;
                    // console.log('it has checked and time priod is:');
                    // console.log(timePeriod);
                }
                var weekDay = {
                    value: DAYS_VALUES[i],
                    name: DAYS_NAMES[i],
                    checked: hasChecked,
                    timePeriod: timePeriod
                };
                retList.push(weekDay);

            }
            return retList;
        }


        $ctrl.open = function (selectedDay) {
            //if the selected day has it own time period
            if (selectedDay.timePeriod) {
                $scope.startTime = selectedDay.timePeriod.startTime;
                $scope.endTime = selectedDay.timePeriod.endTime;
            }
            //if not use the general time period
            else {
                $scope.startTime = $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime;
                $scope.endTime = $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime;
            }
            //show the time period dialog
            DialogService.showDialog('app/components/partial-forms/weekly-work-days/select-time-dialog.template.html', $scope).then(function (e) {
                //if time has changed
                if ($scope.startTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.startTime ||
                    $scope.endTime != $ctrl.selectedWeeklyScheduleInfo.timePeriod.endTime
                ) {

                    var timePeriod = {startTime: $scope.startTime, endTime: $scope.endTime}
                    selectedDay.timePeriod = timePeriod;
                    angular.forEach($ctrl.selectedWeeklyScheduleInfo.weekdays, function (val) {
                        //  console.log(val.weekday);

                        if (val.weekday == selectedDay.value) {

                            val.timePeriod = selectedDay.timePeriod;

                        }
                    });
                    //angular.forEach( $ctrl.allWeekDays,function(val){
                    //    //  console.log(val.weekday);
                    //
                    //    if(val.value==selectedDay.value) {
                    //
                    //        val.timePeriod=selectedDay.timePeriod;
                    //
                    //    }
                    //});

                }

            }, function (e) {//console.log('dialog result');
            });
        };

        $ctrl.ok = function () {
            $scope.showModal = false;
        };

        $ctrl.cancel = function () {
            $scope.showModal = false;
        };

    }

    var WeeklyWorkDays = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/partial-forms/weekly-work-days/partial-form.weekly-work-days.html',
        controller: WeeklyWorkDaysController,
        bindings: {
            selectedWeeklyScheduleInfo: '=?'
        }

    };

    angular
        .module('tikonApp')
        .component('pfWeeklyWorkDays', WeeklyWorkDays)

    //  ServiceItemSchedulesController.$inject = ['$scope','$attrs','$element'];
    WeeklyWorkDaysController.$inject = ['$scope', '$state', '$translate', '$translatePartialLoader', 'DialogService'];


})();

